module.exports = "pegasus/assets/theme6/small/3.jpg";